"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _iframeResizerReact = _interopRequireDefault(require("iframe-resizer-react"));

var _excluded = ["dispatchGetAlerts"];

var IframeContainer = function IframeContainer(props) {
  var dispatchGetAlerts = props.dispatchGetAlerts,
      otherProps = (0, _objectWithoutProperties2.default)(props, _excluded);

  var onMessage = function onMessage(data) {
    if (data.message === 'update alerts') {
      dispatchGetAlerts();
    }
  };

  return /*#__PURE__*/_react.default.createElement(_iframeResizerReact.default, Object.assign({
    scrolling: "no",
    checkOrigin: false,
    heightCalculationMethod: "lowestElement",
    style: {
      border: 'none',
      minHeight: '450px'
    },
    onMessage: onMessage
  }, otherProps));
};

IframeContainer.defaultProps = {
  url: '#',
  height: '100%',
  width: '100%',
  dispatchGetAlerts: function dispatchGetAlerts() {
    return null;
  }
};
var _default = IframeContainer;
exports.default = _default;